import React from 'react'
import classes from './Card.module.css'
import { Typography } from '@mui/material'
import { cash, warning } from '../../../../../../assets/icons'

const IndividualFeeCard = ({ title, content, expense, pendingMonth, index }) => {
  return (
    <div className={expense ? classes.eCardWrapper : classes.cardWrapper}>
      <div className={classes.wrapper}>
        <Typography fontWeight={600} className={classes.CardTitle}>
          {title}
        </Typography>
        <div className={classes.subwrapper}>
          {!expense && (
            <Typography className={classes.CardValue} fontWeight={800}>
              {content}
            </Typography>
          )}
          <div className={expense ? classes.eCardContent : classes.cardContent}>
            {expense && (
              <Typography className={classes.CardValue} fontWeight={800}>
                {content}
              </Typography>
            )}
            {/* {stats && (
              <div className={classes.cardStats}>
                <img src={SucessUp} alt="" />
                <Typography className={classes.statsText}>{stats}%</Typography>
              </div>
            )}
            {stats && <Typography className={classes['card-sub-text']}>than last year</Typography>} */}
          </div>
        </div>
      </div>
      {index === 2 && pendingMonth >= 3 ? (
        <div className={classes.warningbox}>
          <img className={classes.img} src={warning} alt="" />
          <p className={classes.warningtxt}>
            <span className={classes.spantxt}>{parseInt(pendingMonth, 10)} months</span> left
          </p>
        </div>
      ) : (
        <img src={cash} alt="" />
      )}
    </div>
  )
}

export default IndividualFeeCard
